"use client";
import React, { useEffect } from "react";
import ClientOnly from "components/common/ClientOnly";
import SectionContent from "components/home/SectionContent";
import { useBookingStore, useShopStore } from "stores";

export default function HomeContent() {
  const { shop } = useShopStore();
  const {
    bookings,
    selectedDate,
    isLoading,
    loadBookings,
    acceptBooking,
    setSelectedDate
  } = useBookingStore();

  // Load bookings when component mounts or date/shop changes
  useEffect(() => {
    if (selectedDate && shop?.id) {
      loadBookings(selectedDate, shop.id);
    } 
  }, [shop?.id, selectedDate, loadBookings]);

  const handleAccept = async (booking: any) => {
    if (!!booking && shop?.id) {
      try {
        await acceptBooking(booking.id);
        // Reload bookings after accepting
        await loadBookings(selectedDate, shop.id);
      } catch (error) {
        console.error("Error accepting booking:", error);
      }
    }
  };

  return (
    <ClientOnly>
      <div className="flex flex-col h-full">
        <SectionContent
          onAccept={handleAccept}
          isLoading={isLoading}
        />
      </div>
    </ClientOnly>
  );
}